import React from "react";

export default function ProgressBar({ steps, currentStep }) {
  return (
    <nav aria-label="Progress">
      <div className="mx-auto max-w-7xl px-4 py-4 sm:py-6 md:px-8 md:py-12">
        {/* Alleen huidige stap tonen op mobiel */}
        <div className="block md:hidden">
          <div
            className="flex flex-col border-l-4 border-[#1a2a6c] py-1 pl-3"
            aria-current="step"
          >
            <span className="text-xs font-medium text-black">
              Stap {currentStep + 1}
            </span>
            <span className="text-sm font-medium text-[#1a2a6c]">
              {steps[currentStep]}
            </span>
          </div>
        </div>

        {/* Volledige progress bar voor desktop */}
        <ol role="list" className="hidden md:flex md:space-x-8">
          {steps.map((step, index) => (
            <li key={step} className="md:flex-1">
              {index < currentStep ? (
                <div className="group flex flex-col border-t-4 border-[#ff6f61] pt-4 hover:border-[#e65a56]">
                  <span className="text-sm font-medium text-black">
                    Stap {index + 1}
                  </span>
                  <span className="text-lg font-medium text-[#ff6f61] group-hover:text-[#e65a56]">
                    {step}
                  </span>
                </div>
              ) : index === currentStep ? (
                <div
                  aria-current="step"
                  className="flex flex-col border-t-4 border-[#1a2a6c] pt-4"
                >
                  <span className="text-sm font-medium text-black">
                    Stap {index + 1}
                  </span>
                  <span className="text-lg font-medium text-[#1a2a6c]">
                    {step}
                  </span>
                </div>
              ) : (
                <div className="group flex flex-col border-t-4 border-gray-200 pt-4 hover:border-gray-300">
                  <span className="text-sm font-medium text-black">
                    Stap {index + 1}
                  </span>
                  <span className="text-lg font-medium text-gray-500 group-hover:text-[#1a2a6c]">
                    {step}
                  </span>
                </div>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}
